import React from "react";

import axios from "axios";
import { LocalStorage } from "../enums/localStorage";
import { BASE_URL, LOGIN, REFRESH_TOKEN } from "../constants/api";


export async function signIn(params: any) {
  const response = await axios.post(BASE_URL + LOGIN,params.data);
  return response.data;
}

// Refresh token function
export const getRefreshToken = async (): Promise<
{
  message:string,
  data:{
  accessToken: string;
  refreshToken: string;
}
}
> => {
  const refreshToken = localStorage.getItem(LocalStorage.REFRESH_TOKEN);
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  const response = await axios.post(
    BASE_URL + REFRESH_TOKEN ,{
      "refreshToken": refreshToken
    } 
  );

  return response.data;
};


export type ApiResponse<T> = {
  message: string;
  data: T;
};
